<style scoped>
tr:nth-child(odd) {
  background: #f6f6f6;
}
</style>
<template>
  <v-container>
    <v-layout row wrap mt-5 pb-3>
      <v-flex xs12>
        <h3>
          <v-icon large color="yellow">alternate_email</v-icon>
          Change Email
        </h3>
        Here you can change your email.
        <blockquote>
          Please use the save button to change your email.
        </blockquote>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs9>
        <change-email-form class="pa-5"></change-email-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ChangeEmailForm from "@/components/ChangeEmailForm";

export default {
  components: {
    ChangeEmailForm
  }
};
</script>
